import { h, Component } from 'preact'
import { Provider } from 'unistore/preact'
import { createStore } from './store'
import SettingsContainer from './components/SettingsContainer'

class CalendarSettingsWidget extends Component {
    constructor(props) {
        super(props)
        this.store = createStore(props)
    }

    render(props) {
        return (
            <Provider store={this.store}>
                <SettingsContainer />
            </Provider>
        )
    }
}

export default CalendarSettingsWidget
